import { $, $$, sliderConfig } from '@utils';
import Swiper from 'swiper';
import { Navigation, Scrollbar, A11y, FreeMode } from 'swiper/modules';

function init() {
  if (!$('[data-au-tribunes-slider]')) return;

  buildSlider();
}

function buildSlider() {
  $$('[data-au-tribunes-slider]').forEach((slider) => {
    new Swiper(slider, {
      modules: [Navigation, Scrollbar, A11y, FreeMode],
      ...sliderConfig,
      breakpoints: {
        1024: {
          spaceBetween: 40,
        },
      },
    });
  });
}

export default { init };
